export default __webpack_public_path__ + "static/media/flag-algeria.e76a9cfb.svg";